document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function() {
        if (getElements(document.querySelectorAll('.bakingSoda'))) {
            loadAnimationOnScroll({
                target: '#bakingSoda',
                path: '/wp-content/themes/netUpwhite/assets/lottie/baking-soda.json',
                duration: 15
            });
            loadAnimationOnScroll({
                target: '#bubblesBg',
                path: '/wp-content/themes/netUpwhite/assets/lottie/bubbles-bg.json',
                duration: 15
            });
        }
    });
});

function loadAnimationOnScroll(obj) {
    let triggered = false;

    gsap.to({}, {
        scrollTrigger: {
            trigger: obj.target,
            start: "-500px bottom", // 500px vor dem Eintritt ins Viewport
            onEnter: () => {
                if (!triggered) {
                    triggered = true;
                    createAnimation(obj);
                }
            },
            once: true // sicherstellen, dass es nur einmal ausgelöst wird
        }
    });
}

function createAnimation(obj) {
    let playhead = { frame: 0 };
    let animation = lottie.loadAnimation({
        container: document.querySelector(obj.target),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: obj.path
    });

    animation.addEventListener("DOMLoaded", function() {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: obj.target,
                start: "top bottom"
            },
            repeat: -1 // unendlich bubbles
        });

        tl.to(playhead, {
            frame: animation.totalFrames - 1,
            duration: obj.duration,
            ease: "none",
            onUpdate: () => animation.goToAndStop(playhead.frame, true)
        });
    });
}
